import React, { ReactNode } from 'react';

interface RecordSourceWrapperIconProps {
  className: string;
  children: ReactNode;
}

const RecordSourceWrapperIcon = ({
  className,
  children
}: RecordSourceWrapperIconProps) => (
  <div
    style={{
      display: 'flex',
      width: '20px',
      height: '20px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '62.5px'
    }}
    className={className}
  >
    {children}
  </div>
);

export default RecordSourceWrapperIcon;
